// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1b96c677","453":"1d4715ad","455":"940f2e87","952":"f1644dcd"}[chunkId] + ".chunk.js";
};